import * as fromProjects from '../actions/projects.action';
import { Projects, ProjectsFilter } from '@usimweb/core/models';

import { MakeEntitie } from '../makeentitie';

interface MouseEvent {
  x: number;
  y: number;
}

export interface ProjectsState {
  entities: { [uuid: string]: Projects };
  loaded: boolean;
  loading: boolean;
  newProject: boolean;
  mouseEvent: MouseEvent;
  filter: ProjectsFilter;
}

export const initialState: ProjectsState = {
  entities: {},
  loaded: false,
  loading: false,
  filter: { visibilityFilter: '-', searchFilter: '', favouriteFilter: false },
  newProject: false,
  mouseEvent: { x: 1255, y: 483 },
};

export function reducer(state = initialState, action: fromProjects.ProjectsAction): ProjectsState {
  switch (action.type) {
    case fromProjects.LOAD_PROJECTS: {
      return {
        ...state,
        loading: true,
      };
    }

    case fromProjects.LOAD_PROJECTS_SUCCESS: {
      const projects = action.payload;
      const entities = MakeEntitie.projects(state, projects);
      return {
        ...state,
        loading: false,
        loaded: true,
        entities,
      };
    }

    case fromProjects.LOAD_PROJECT_SUCCESS: {
      const project = action.payload;
      const entities = MakeEntitie.project(state, project);
      return {
        ...state,
        loading: false,
        loaded: true,
        entities,
      };
    }

    case fromProjects.LOAD_PROJECTS_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }

    case fromProjects.CREATE_PROJECTS_SUCCESS: {
      const project = action.payload;
      const entities = {
        ...state.entities,
        [project.uuid]: project,
      };

      return {
        ...state,
        entities,
        newProject: true,
        // FIXME !!!
        mouseEvent: { x: 1255, y: 483 },
      };
    }

    case fromProjects.DELETE_PROJECT: {
      return {
        ...state,
        loading: true,
      };
    }

    case fromProjects.DELETE_PROJECT_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }

    case fromProjects.DELETE_PROJECT_SUCCESS: {
      const projects = action.payload;
      const { [projects.uuid]: removed, ...entities } = state.entities;

      return {
        ...state,
        entities,
        loading: false,
        loaded: false,
      };
    }

    case fromProjects.FAV_PROJECT_SUCCESS: {
      const project = { ...action.payload, ['is_favorite']: !action.payload.is_favorite };

      const entities = {
        ...state.entities,
        [project.uuid]: project,
      };

      return {
        ...state,
        entities,
      };
    }

    case fromProjects.ADD_USER_PROJECT_SUCCESS: {
      const obj = action.payload;

      const project = state.entities[obj.uuid];
      const users = project.users;

      const user = obj.data.username;
      const newUsers = [...users, user];
      const user_roles = obj.user_roles;

      const newProject = { ...project, ['users']: newUsers, ['user_roles']: user_roles };
      const entities = { ...state.entities, [newProject.uuid]: newProject };

      return {
        ...state,
        entities,
      };
    }

    case fromProjects.RM_USER_PROJECT_SUCCESS: {
      const obj = action.payload;

      const project = state.entities[obj.uuid];
      const users = project.users.filter((x) => x !== obj.data.username);

      // const newUser = { ...users, ...obj.data.username };
      const newProject = { ...project, ['users']: users };
      const entities = { ...state.entities, [newProject.uuid]: newProject };

      return {
        ...state,
        entities,
      };
    }

    case fromProjects.CHANGE_USER_ROLE_SUCCESS: {
      const obj = action.payload;

      const project = state.entities[obj.uuid];

      const newRoles = { ...project.user_roles, [obj.data.username]: obj.data.role };

      // project.user_roles[obj.data.username] = obj.data.role;
      // const userRoles = project.user_roles;

      // const newUser = { ...users, ...obj.data.username };
      const newProject = { ...project, ['user_roles']: newRoles };
      const entities = { ...state.entities, [newProject.uuid]: newProject };

      return {
        ...state,
        entities,
      };
    }

    case fromProjects.REQUEST_SUPPORT_SUCCESS:
    case fromProjects.UNREQUEST_SUPPORT_SUCCESS: {
      const project = action.payload;
      const entities = {
        ...state.entities,
        [project.uuid]: project,
      };

      return {
        ...state,
        entities,
      };
    }

    case fromProjects.SET_PROJECTS_FILTER: {
      const newState = { ...state, filter: action.payload };
      return newState;
    }

    case fromProjects.CLEAR_PROJECTS: {
      return {
        ...state,
        entities: {},
        loading: false,
        loaded: false,
      };
    }
  }

  return state;
}

export const getProjectsEntities = (state: ProjectsState) => state.entities;
export const getProjectsLoading = (state: ProjectsState) => state.loading;
export const getProjectsLoaded = (state: ProjectsState) => state.loaded;

export const getProjectCreated = (state: ProjectsState) => state.newProject;
export const getProjectsFiltered = (state: ProjectsState) => state.filter;
